export default {
  commits: [
    "I was told to leave it alone, but I have this thing called OCD, you see",
    "I'M PUSHING.",
    "fixed issue",
    "When I wrote this only god an I knew how it worked, Now, only god knows.",
    "probably shouldn't do this on a Thursday evening. meh whats the worst that can happen?",
    "SEND HELP",
    "Forsaken bug I command thee, WORK!",
    "changed things",
    "ok, it's 2 AM. It works now, I think",
    "Oh lord who wrote this?",
    "fixing Avi's bug",
    "fixing the bug created from fixing Avi's bug",
    "Never gonna give you up",
    "Become a programmer, they said. It'll be fun, they said.",
    "I need either sleep coffee or a glass of martini",
    "Hey you reading this, let's go out for a drink at my favorite Bar, Foo",
    "dunno",
    "Blaming regex",
    "The guys on StackOverFlow said it will work now",
    "I'm sorry future me",
    "me so sorry",
    "I'm hungry",
    "I don't know how to fix your printer but I fixed the bug on line 317",
    "IT WORKS!!!!",
    "fixed",
    "Testing the test",
    "TODO: write meaningful commit messages",
    "WHY IS JS SO WEIRD?",
    "WHY IS C++ SO WEIRD?",
    "WHY IS JAVA SO WEIRD?",
    "if it works, leave it be",
    "I love my job, But I hate this bug",
    "Out of all the bugs in the world, I hate you the most",
    "Don't tell my boss I google everything",
    "done",
    "oops",
    "perfect",
    "God help us all",
    "yolo",
    "what year is that?",
    "Legacy code don't touch",
    "added code",
    "Who let the bugs out?",
    "Who knows?!",
    "Don't remeber what I changed but it must be important since it's 1 AM already",
    "a descriptive message",
    "To those in the future reading this, Good luck dear friends. You'll need it.",
    "Ugh, Bad rebase",
    "Low on caffeine, Please forgive coding style",
    "I HATE CSS",
    "Major fix",
    "Minor fix",
    "Haha",
    "it's a secret",
    "Elon Musk must be an alien",
    "Never let a bug know you're in a hurry, They smell fear",
    "Proceed with caution",
    "There are many unsolved mysteries of the universe, this bug is one of them.",
    "After 5 hours, 4 cups of coffee, and 3 tears, it works now!",
    "Ignore last commit",
    "git rebase is scary",
    "The problem with troubleshooting is that trouble shoots back.",
    "Huston we have a problem",
    "errors were made",
    "Help, I Need Somebody, Help! Not Just Anybody! Help!",
    "You know what me and this bug have in common? I hate us both.",
    "OH HELL YEAH, I ROCK!",
    "Someone needs to tell the new intern to stop touching legacy code",
    "Give a man a fish, and he will eat for a day. Give a man unit testing, and he will forget to eat and starve to death.",
    "You know what? Screw it",
    "Awesomeness happened",
    "You just watched a master in action",
    "I'll definetly get a raise for this",
    "Bugs may survive nuclear wars, but they didn't survive this",
    "Oh praise our lord and savior Google.",
    "One day I'll fix this, just not today",
    "IT COMPILES!",
    "I wonder if this bug thinks about me like I think about him.",
    "Just commiting so I can go home",
    "Is there an achievement for this?",
    "It's a me Mario",
    "LOL",
    "I will not apologize for art",
    "I give up, somebody else figure this out.",
    "I'll explain when you're older",
    "well turns out I was wrong",
    "Thrusday, 5pm.",
    "Fixed things and stuff",
    "I regret nothing",
    "I regret everything",
    "And they said I don't know JS",
    "Fixing this for the client, not because it needs fixing",
    "it's not a bug mom, It's a feature",
    "It's called art, Google it.",
    "I found this on the 4th page of google search.",
    "The Indian guy on Youtube just saved my job",
    "It works on my machine",
    "These are not the commit messages you're looking for",
    "Halo? efo ata? ata po? po lo po po po",
    "My mom always said the older you're the better you get",
    "I'm not superstitious or anything but don't try to fix this bug wearing a red shirt",
    "I'm not insane. My mom had me tested.",
    "Well this escalated quickly",
    "This is an unfortunate turn of events",
    "You want a production issue? because that's how you get a production issue",
    "Me smart, me good at computer",
    "Now I get a different error message, YAY!",
    "Never spend 6 minutes doing something by hand when you can spend 6 hours failing to automate it",
    "When they said ninja programmer for hire I didn't think they were serious",
    "Why?!",
    "Oh, that's why",
    "Look ma no hands!",
    "Trust me I'm an engineer",
    "We'll figure this out on Sunday",
    "You can't see but I'm making a very angry face right now",
    "Spilled coffee on my keyboard, how is your day going?",
    "And my wife thinks I'm smart...",
    "debugged the bug",
    "Let this be a lesson for all",
    "EPIC STUFF",
    "Make peace not bugs",
    "I'll bet you 50 shekels it's working now",
    "Thank god",
    "Solving the Israeli Palestinian conflict might be easier than this",
    "Not sure...",
    "small is a real HTML tag, who knew?",
    "Java syntax",
    "All because of a semicolon?",
    "OOP is OP",
    "Rent is expensive in Tel Aviv",
    "Improvements",
    "Day 2153 of pretending to know what I'm doing",
    "The sun? never heard of it.",
    "So you're telling me people used to code without google?",
    "I knew studying Linear Algebra would help me center this div",
    "Hard in training easy in production",
    "Note to self: Sleep is important.",
    "Become a programmer they said, it'll be fun the said",
    "I love the sound of my mechanical keyboard so I'm typing this really long commit message to hear it",
    "EZ",
    "I must enjoy torturing myself",
    "2 McRoyals and a coke please.",
  ],
};
